import { lineService } from '@/services/line.service'
import i18n from '@/i18n'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'LineDialogDataTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // estados
        states: [],
        // errores para el campo del núm de tarjeta sim 
        simCardError: [],
        // errores para el campo del núm de línea
        lineError: [],
        // carriers
        carriers: [],
        // loading
        loadingStates: false,
        loadingCarriers: false,
        // model para el formulario
        isValidForm: false,
        // para validación de número de línea y tarjeta sim
        actualLineNumber: null,
        actualSimCard: null
    }),
    computed: {
    },
    created () {
        this.actualLineNumber = this.model.lineNumber
        this.actualSimCard = this.model.simCard
        this.getData()
    },
    mounted () {
    },
    methods: {
        /**
         * Mensaje de error cuando el núm de sim card está duplicado
         */
        simCardDuplicateMethod() {
            if (this.model.simCard === this.actualSimCard) return
            lineService.validateSimCardNumber(this.model.simCard).then(response => {
                if (response) {
                    this.simCardError.push(`${i18n.t('line.simCardDuplicate')}`)
                } else {
                    this.simCardError = []
                }
            })
        },
        /**
         * Mensaje de error cuando el núm de línea está duplicado
         */
        lineDuplicateMethod() {
            if (this.model.lineNumber === this.actualLineNumber) return
            lineService.validateLineNumber(this.model.lineNumber).then(response => {
                if (response) {
                    this.lineError.push(`${i18n.t('line.duplicate')}`)
                } else {
                    this.lineError = []
                }
            })
        },
        /**
         * Datos para los selectores
         */
        async getData() {
            this.loadingStates = true
            this.loadingCarriers = true
            this.states = await lineService.getStates()
            this.carriers = await lineService.getCarriers()
            this.loadingStates = false
            this.loadingCarriers = false
        },
        /**
         * Cada vez que se modifica la selección del portador, se cargan
         */
        carrierSelectedFunction (newValue) {
            this.model.carrier = newValue.id ? newValue.id : newValue;
        },
        /**
         * Cada vez que se modifica la selección del estado, se cargan
         */
        stateSelectedFunction (newValue) {
            this.model.stateId = newValue.id ? newValue.id : newValue;
        },
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.lineDialogDataTabForm) {
                this.$refs.lineDialogDataTabForm.resetValidation()
            }
        }
    }
}
